import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const HUBSkeleton: React.FC<{}> = ({}) => {
    return (
        <div className="recruiting-hub">
            <div className="left">
                <Skeleton height={230} borderRadius={15} />
                <Skeleton containerClassName="recruits-skeleton" />
            </div>
            <div className="right">
                <div className="latest-news-card">
                    <div className="title-container">
                        <Skeleton containerClassName="title" height={30} width={140} borderRadius={15} />
                        <Skeleton containerClassName="button" height={30} width={120} borderRadius={15} />
                    </div>
                    <div className="content">
                        <Skeleton containerClassName="article-skeleton" />
                        <Skeleton containerClassName="article-skeleton" />
                    </div>
                </div>
                <div className="upcoming-events-card">
                    <div className="title-container">
                        <Skeleton containerClassName="title" height={30} width={180} borderRadius={15} />
                        <Skeleton containerClassName="button" height={30} width={120} borderRadius={15} />
                    </div>
                    <div className="content">
                        <Skeleton containerClassName="event-card-skeleton" />
                        <Skeleton containerClassName="event-card-skeleton" />
                        <Skeleton containerClassName="event-card-skeleton" />
                    </div>
                </div>
            </div>
        </div>
    );
};
